import PageActionButton, { type PageActionButtonProps } from 'components/Button/PageActionButton';
import type { PageActionModel } from 'components/shared/Routing/PageAction';

export default function CMSLinkButton({
    action,
    children,
    onClick,
    ...restProps
}: { action?: PageActionModel } & PageActionButtonProps) {
    if (!action) return null;

    // todo niels den her havde css classes på
    return (
        <PageActionButton action={action} {...restProps}>
            {children}
        </PageActionButton>
    );
}
